import { createClient } from '@/lib/supabase/client'

const ADMIN_URL = () =>
  (process.env.NEXT_PUBLIC_ADMIN_APP_URL ?? 'http://localhost:4028').replace(/\/$/, '')

export async function getAccessToken(): Promise<string | null> {
  const supabase = createClient()
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}

export async function proxyAdmin(
  path: string,
  init: RequestInit & { auth?: boolean } = {},
): Promise<Response> {
  const headers = new Headers(init.headers)
  if (init.auth !== false) {
    const token = await getAccessToken()
    if (token) headers.set('authorization', `Bearer ${token}`)
  }
  if (init.body && !headers.has('content-type'))
    headers.set('content-type', 'application/json')

  return fetch(`${ADMIN_URL()}${path}`, {
    ...init,
    headers,
    cache: 'no-store',
  })
}

export function adminBaseUrl() {
  return ADMIN_URL()
}
